import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import Localization from "../../localization";
import { loadPage } from "../../redux/actions/pages";
import { changeLogin } from "../../redux/actions/options";
import { getUrl } from "../../utils/helper";
import { getMe } from "../../redux/selectors/me";
import Item from "./item";
import IconShape from "../icons/shape";

class Carousel extends Component {
    constructor(props) {
        super(props);

        this.state = {
            object: null,
            index: 0,
        };

        this._handleResize = this._handleResize.bind(this);
        this._loadPage = this._loadPage.bind(this);
        this._updateState = this._updateState.bind(this);
        this._updateStateSpecial = this._updateStateSpecial.bind(this);
        this._updateTicker = this._updateTicker.bind(this);
    }

    componentDidMount() {
        this._loadPage();
        this._handleResize();

        this._ticker = setInterval(this._updateTicker, 7000);
    }

    componentDidUpdate(prevProps) {
        if (this.props.homeData !== prevProps.homeData) {
            if (
                location.pathname.includes(getUrl("")) ||
                location.pathname.includes("/" + this.props.locale)
            ) {
                this._updateState("home", "blue", this.props.homeData);
            }
        } else if (this.props.spaceData !== prevProps.spaceData) {
            if (location.pathname.includes(getUrl("spaces_booking"))) {
                this._updateStateSpecial(
                    "space",
                    "orange",
                    this.props.spaceData
                );
            }
        } else if (this.props.infoData !== prevProps.infoData) {
            if (location.pathname.includes(getUrl("about"))) {
                this._updateState("info", "orange", this.props.infoData);
            }
        } else if (this.props.artistData !== prevProps.artistData) {
            if (location.pathname.includes(getUrl("artists"))) {
                this._updateState("artist", "pink", this.props.artistData);
            }
        } else if (this.props.blogData !== prevProps.blogData) {
            if (location.pathname.includes(getUrl("bookmarks"))) {
                this._updateState("blog", "blue", this.props.blogData);
            }
        } else if (this.props.classeData !== prevProps.classeData) {
            if (location.pathname.includes(getUrl("practices"))) {
                this._updateState("classe", "blue", this.props.classeData);
            }
        } else if (this.props.openData !== prevProps.openData) {
            if (location.pathname.includes(getUrl("opencalls"))) {
                this._updateState("open", "blue", this.props.openData);
            }
        } else if (this.props.pathname !== prevProps.pathname) {
            this.setState(
                {
                    object: null,
                },
                () => this._loadPage()
            );
        }
    }

    _updateTicker() {
        let newIndex = this.state.index + 1;
        if (
            !this.state.object ||
            newIndex > this.state.object.data.length - 1
        ) {
            newIndex = 0;
        }
        this.setState({
            index: newIndex,
        });
    }

    _checkExtraPages() {
        return (
            location.pathname.includes(getUrl("account")) ||
            location.pathname.includes(getUrl("privacy")) ||
            location.pathname.includes(getUrl("terms")) ||
            location.pathname.includes(getUrl("calendar")) ||
            location.pathname.includes(getUrl("cookies"))
        );
    }

    _loadPage() {
        if (this._checkExtraPages()) return null;

        if (location.pathname.includes(getUrl("about"))) {
            if (this.props.infoData) {
                this._updateState("info", "orange", this.props.infoData);
            } else {
                this.props.loadPage("info");
            }
        } else if (location.pathname.includes(getUrl("spaces_booking"))) {
            if (this.props.spaceData) {
                this._updateStateSpecial(
                    "space",
                    "orange",
                    this.props.spaceData
                );
            } else {
                this.props.loadPage("spaces");
            }
        } else if (location.pathname.includes(getUrl("bookmarks"))) {
            if (this.props.blogData) {
                this._updateState("blog", "blue", this.props.blogData);
            } else {
                this.props.loadPage("blog");
            }
        } else if (location.pathname.includes(getUrl("artists"))) {
            if (this.props.artistData) {
                this._updateState("artist", "pink", this.props.artistData);
            } else {
                this.props.loadPage("artists");
            }
        } else if (location.pathname.includes(getUrl("practices"))) {
            if (this.props.classeData) {
                this._updateState("classe", "blue", this.props.classeData);
            } else {
                this.props.loadPage("classes");
            }
        } else if (location.pathname.includes(getUrl("opencalls"))) {
            if (this.props.openData) {
                this._updateState("open", "blue", this.props.openData);
            } else {
                this.props.loadPage("open_calls");
            }
        } else {
            if (this.props.homeData) {
                this._updateState("home", "blue", this.props.homeData);
            } else {
                this.props.loadPage("homepage");
            }
        }
    }

    _updateState(id, color, data) {
        this.setState({
            index: 0,
            object: {
                id,
                color,
                title: data.title,
                subtitle: data.subtitle,
                data: data.new_banners,
                buttonName: data.buttonName,
                onClick: data.onClick,
                buttonVisible: data.buttonVisible,
            },
        });
    }

    _updateStateSpecial(id, color, data) {
        const { user, locale } = this.props;

        this.setState({
            index: 0,
            object: {
                id,
                color,
                title: data.title,
                subtitle: data.subtitle,
                data: data.new_banners,
                buttonName: Localization[locale].account.button_booking,
                onClick: () => {
                    if (!user) {
                        this.props.changeLogin(true);
                    } else {
                        this.props.history.push(getUrl("account/spaces"));
                    }
                },
                buttonVisible: !user || user.is_local,
            },
        });
    }

    _handleResize() {
        const vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty("--vh", `${vh}px`);
    }

    _renderPagination() {
        const { object } = this.state;

        if (!object || object.data.length <= 1) return null;

        return (
            <div className="mx-16 xl:mx-50 hidden xl:block absolute bottom-0 right-0 z-20">
                <div className="flex mb-84 xl:mb-100">
                    {object.data.map((item, index) => {
                        if (index === this.state.index) {
                            return (
                                <IconShape
                                    key={index}
                                    className="w-24 h-22 ml-8"
                                />
                            );
                        }

                        return (
                            <div
                                key={index}
                                onClick={() => {
                                    this.setState({
                                        index,
                                    });
                                }}
                                className="w-22 h-22 mr-1 ml-8 rounded-full border-white border"
                            />
                        );
                    })}
                </div>
            </div>
        );
    }

    render() {
        const { object } = this.state;

        if (this._checkExtraPages()) return null;

        if (!object) return null;

        return (
            <div className="fixed w-full carousel-content">
                <div className={"flex h-full flex-col relative"}>
                    {object.data.map((item, index) => (
                        <Item
                            key={object.id + "_" + item.key}
                            title={item.attributes.title}
                            subtitle={item.attributes.subtitle}
                            url={item.attributes.url}
                            bannerUrl={
                                item.attributes.banner &&
                                item.attributes.banner.url
                            }
                            manualColor={item.attributes.color}
                            color={object.color}
                            buttonName={object.buttonName}
                            buttonVisible={object.buttonVisible}
                            onClick={object.onClick}
                            active={index === this.state.index}
                        />
                    ))}
                    {this._renderPagination()}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    locale: state.app.locale,
    homeData: state.pages.homepage,
    infoData: state.pages.info,
    openData: state.pages.open_calls,
    spaceData: state.pages.spaces,
    classeData: state.pages.classes,
    blogData: state.pages.blog,
    artistData: state.pages.artists,
    user: getMe(state),
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            loadPage,
            changeLogin,
        },
        dispatch
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(Carousel);
